import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
export default function () {
  let initialized = false;
  extend(Page.prototype, 'oninit', function () {
    if (initialized) {
      return;
    }

    // We only show the modal if the first page loaded was the index page
    // And that new updates are available
    // And that the user *must* accept them
    if (app.current.matches(IndexPage)) {
      const user = app.session.user;
      if (user && user.fofTermsPoliciesMustAccept()) {
        // Timeout is necessary because there is a redraw error otherwise
        // Lazy load the modal component to reduce initial bundle size
        setTimeout(() => {
          app.modal.show(() => import(/* webpackChunkName: 'forum/components/AcceptPoliciesModal', webpackMode: 'lazy-once' */ './components/AcceptPoliciesModal'));
        }, 0);
      }
    }
    initialized = true;
  });
}flarum.reg.addChunkModule('105', '877', 'fof-terms', 'forum/components/AcceptPoliciesModal');